import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DATE_FORMAT } from 'src/app/shared/constants';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import { IncidentReportDto } from '@services';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';

@Component({
    selector: 'app-compliance-manager-section',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
    ],
    templateUrl: './compliance-manager-section.component.html',
})
export class ComplianceManagerSectionComponent {
    @Input() incidentReport: IncidentReportDto;
    @Input() isReadOnly: boolean = false;
    @Input() yesOrNoOptions: any;

    public dateFormat = DATE_FORMAT;
}
